// features/subscription/couponVerifySlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET,POST } from "../../../utils/Methods"; 
import { APIS } from "../../../utils/APIS";
import { IDS } from "../../../utils/IDS";

// 🔹 Async Thunk: Verify Coupon
export const vendorSubscription = createAsyncThunk(
  "/vendorSubscription",
  async (data, { rejectWithValue }) => {
    try {
      const { user_id, subscription_id, amount,razorpay_payment_id } = data;

      // Build query params
      const query = `?user_id=${user_id}&subscription_id=${subscription_id}&amount=${amount}&razorpay_payment_id=${razorpay_payment_id}`;

      // API call (GET request as per your Postman link)
      const res = await POST(`${APIS.Register.VENDOR_SUBSCRIPTION}${query}`);

      console.log("VENDOR_SUBSCRIPTION Response:", res);
      return res;
    } catch (error) {
      console.error("VENDOR_SUBSCRIPTION API Error:", error);
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// 🔹 Slice
const vendorSubscriptionSlice = createSlice({
  name: "vendorSubscription",
  initialState: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  reducers: {
    resetCouponVerifyState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(vendorSubscription.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(vendorSubscription.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(vendorSubscription.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const { resetVendorSubscriptionState } = vendorSubscriptionSlice.actions;

export default vendorSubscriptionSlice.reducer;